import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Chart } from 'chart.js/auto';
import { IDashboardChart } from '../../../../interfaces/Dashboard/IDashboardChart';
import { HttpClient } from '@angular/common/http';
import { IGenericServiceResponse } from '../../../../interfaces/IServiceResponse';
import { environment } from '../../../../../environments/environment';
import { IDateTimeRange } from '../../../../interfaces/Dashboard/IDateTimeRange';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-dashboard-admission-reason',
    templateUrl: './dashboard-admission-reason.component.html',
    styleUrls: ['./dashboard-admission-reason.component.css'],
    standalone: false
})
export class DashboardAdmissionReasonComponent {
  @Input() dateTimeRange: IDateTimeRange | null = null; // Input to receive the selected date range
  public admissionData: IDashboardChart | null = null;

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.fetchData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dateTimeRange'] && !changes['dateTimeRange'].firstChange) {
      this.fetchData(); // Fetch data whenever dateTimeRange changes
    }
  }

  BarChart(): void {
    const labels = this.admissionData?.labels || [];
    const datasets = this.admissionData?.dataSet || [];

    const data = {
      labels: labels,
      datasets: datasets.map((dataset, index) => ({
        label: this.translate.instant(dataset.label || ''),
        data: dataset.data,
        backgroundColor: [dataset.backgroundColor],
        borderColor: 'rgba(128, 128, 128, 0.6)', // Gray border color
        borderRadius: 10,
        borderWidth: 1,
      })),
    };

    new Chart('admissionReason', {
      type: 'bar',
      data: data,
      options: {
        maintainAspectRatio: false,
        indexAxis: 'x',
        scales: {
          x: {
            ticks: {
              stepSize: 1, // Set step size to 1 to display whole numbers
            },
          },
        },
        elements: {
          bar: {
            borderWidth: 1,
          },
        },
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: this.translate.instant('Admission Reason'),
          },
        },
      },
    });
  }

  fetchData(): void {
    let chartStatus = Chart.getChart('admissionReason');
    if (chartStatus != undefined) {
      chartStatus.destroy();
    }

    this.http
      .post<IGenericServiceResponse<IDashboardChart>>(
        `${environment.BACKEND_URL}Dashboard/AdmissionReason`,
        {
          startDate: this.dateTimeRange?.startDate,
          endDate: this.dateTimeRange?.endDate,
          offset: new Date().getTimezoneOffset() / 60,
        }
      )
      .subscribe((data) => {
        this.admissionData = data.data;
        this.cdr.detectChanges(); // Trigger change detection
        if (this.admissionData) {
          this.BarChart();
        }
      });
  }
}
